module.exports = __webpack_public_path__ + "img/default-car.f5bd7e25.jpg";